var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-queue"},[_c('div',{staticClass:"flex-grow-0"},[_c('ViewFilterButtons',{attrs:{"on_view_change":_vm.view_change,"view_options":_vm.view_options}})],1),_c('div',{staticClass:"player-container flex-grow flex"},[_c('div',{staticClass:"player-listing-wrapper"},[_c('PlayerListing',{attrs:{"view_options":_vm.view_options,"players":_vm.player.roster,"on_player_select":_vm.view_player}})],1),_c('div',{staticClass:"player-viewer-wrapper slide-in-on-mobile",class:{
				'show-slide-in': _vm.selected_player,
			}},[_c('PlayerViewer',{attrs:{"selected_player":_vm.selected_player,"close":function () {
						this$1.selected_player = null;
					}}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }